import { css } from '@emotion/react';
import { useDeleteOrganizationEmailMutation } from 'generated/graphql';
import { useStore } from 'hooks/useStore';
import { useState } from 'react';
import { ItemForm } from './ItemForm';
import { Button } from 'components/Button';
import { IconEdit } from 'icons/icon-edit';
import { IconTrash } from 'icons/icon-trash';
import { emailTypeLabel } from '../emailTypeLabel';

export const EmailItem = ({ item, newForm }: { item?: any; newForm?: boolean }) => {
	const [editing, setEditing] = useState<boolean>(false);

	const [{ fetching }, deleteOrganizationEmail] = useDeleteOrganizationEmailMutation();

	const { notifications } = useStore();

	return (
		<div
			css={css`
				border-radius: 12px;

				${!newForm &&
				!editing &&
				css`
					padding: 8px;
				`};

				display: flex;
				justify-content: space-between;
				align-items: center;
				gap: 12px;

				&:hover {
					${!editing &&
					!newForm &&
					css`
						background: #f5f5ff;
					`};
					// background: red;;
				}
			`}
		>
			{editing || newForm ? (
				<ItemForm item={item} onClose={() => setEditing(false)} />
			) : (
				<div
					css={css`
						align-items: center;
						display: flex;
						justify-content: space-between;
						width: 100%;
					`}
				>
					<div
						css={css`
							display: flex;
							gap: 8px;
							flex-grow: 1;
						`}
					>
						<div
							css={css`
								width: 136px;
								flex-shrink: 0;
							`}
						>
							{emailTypeLabel[item?.type]}
						</div>
						<div>{item?.email}</div>
					</div>

					<div
						css={css`
							display: flex;
							flex-shrink: 0;
						`}
					>
						<Button
							ghost
							square
							onClick={() => {
								setEditing(true);
							}}
						>
							<IconEdit />
						</Button>

						<Button
							isProcessing={fetching}
							ghost
							square
							onClick={() => {
								// alert('Modal to confirm delete.');
								deleteOrganizationEmail({ id: item.id }).then((data) => {
									if (!data.error) {
										notifications.addNotification({
											title: '✅ Hotovo',
											message: 'Email byl odebrán.',
										});
									}
								});
							}}
						>
							<IconTrash />
						</Button>
					</div>
				</div>
			)}
		</div>
	);
};
